const copy = {
  compositeCallout: {
    heading: "Still can't find what you need?",
    logInButton: 'Log in to contact support',
    troubleLoggingInButton: "Can't login? Submit a ticket",
    chatWithHCAButton: 'Chat with our Help Center Assistant',
    contactSupportButton: 'Contact support',
  },
  emptyState: {
    oops: {
      heading: "Looks like something isn't working",
      description: 'Something went wrong. Try again later.',
    },
    noResult: {
      heading: 'No article is found',
      description: "We couldn't find the article. Please try again later",
    },
  },
  errors: {
    log: (articleId: string): string =>
      `Unable to fetch article ${articleId} due to server error`,
  },
};

export default copy;
